import { render, staticRenderFns } from "./copyIcon.vue?vue&type=template&id=74a6b9c6&scoped=true"
import script from "./copyIcon.vue?vue&type=script&lang=js"
export * from "./copyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6b9c6",
  null
  
)

export default component.exports